import * as React from 'react';
import { connect } from 'react-redux';
import { SwordSearch, UserList, PostcodeList } from 'src/app/Partials';
import { UsersDispatcher } from 'src/app/Container';
import { GlobalPrivateState } from 'src/api';

import './Admin.page.scss';
import { Switch, Route } from 'react-router';
import PricingsAccessories from 'src/app/Partials/Admin/Pricing/PricingsAccessories';
import PricingsWashbasin from 'src/app/Partials/Admin/Pricing/PricingsWashbasin';
import Pricings from 'src/app/Partials/Admin/Pricing/Pricings';
import PricingsMarket from 'src/app/Partials/Admin/Pricing/PricingsMarket';

export interface AdminPageProps {
  users: GlobalPrivateState['users'];
}

export class AdminPageComponent extends React.Component<AdminPageProps> {

  public render() {
    return (
      <div className="page-configurations">
        <div className="page-admin pb-3">
          <div className="container">
            <SwordSearch /> 
            <div className="row">
              <Switch>
                <Route path="/" exact={true} component={UserList} />
                <Route path="/postcodes" exact={true} component={PostcodeList} />
                <Route path="/pricings-accessories/:pricingId" exact={false} component={PricingsAccessories} />
                <Route path="/pricings-washbasin/:pricingId" exact={false} component={PricingsWashbasin} />
                <Route path="/pricings-market/:pricingId" exact={false} component={PricingsMarket} />
                <Route path="/pricings" exact={true} component={Pricings} />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const AdminPage = connect((state: GlobalPrivateState) => ({
  user: state.user,
}))(AdminPageComponent);